import React from "react";
import casestudydata from "../pages/casestudydata.json";

const ArticleCover = props => {
  return (
    <div className="Article">
      <div className={props.coverimage}>
        <div className="tile">
          <h1 className="article-title">{props.title}</h1>
          <p className="byline">{props.subtitle}</p>
          <p>{props.description}</p>
        </div>
      </div>
    </div>
  );
};

const ArticleCoverData = () =>
  casestudydata.casestudies.map(casestudy => (
    <ArticleCover
      key={casestudy.id}
      title={casestudy.titlelong}
      subtitle={casestudy.brandname}
      description={casestudy.descriptionlong}
      coverimage={casestudy.imgclassname}
    />
  ));

export default ArticleCoverData;
